var searchScroller = (function ($, options) {

    'use strict';

    /* Public scope and variables */
    var allowSearch = false;
    var self = {};
    self.settings = {};

    /* Private functions */

    function init() {
        $.extend(self.settings, options);
        bootstrap();
    }

    function bootstrap() {
        bindEvent();
    }

    function bindEvent() {
        $(document).on('facetwp-loaded', function() {
            scrollToSearchResults();
        });
    }

    function scrollToSearchResults() {
        $('html, body').animate({ scrollTop: 0 }, 500);
    }

    init();

    return self;

}(jQuery, {}));